import React, { Component } from "react";
import TopOptions from "../components/TopOptions";
import MyProductsTable from "../components/MyProductsTable";
import styled from "styled-components";
import { connect } from "react-redux";
import { RoutesPath } from "../values/RoutesPath";
import { acl } from "../services/acl";
class MyProductsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: false,
        };
    }
    async componentDidMount() {
        document.title = "Produits - Sobrus Labs";
    }
    render() {
        return (
            <Main_container className="Main_container">
                <TopOptions title="Produits">
                    {acl.product.list() && (
                        <a onClick={() => this.props.history.push(`${RoutesPath.product.list}`)} className="btn_white">
                            Afficher tous les produits
                        </a>
                    )}
                    {acl.product.suggestion.list() && (
                        <a onClick={() => this.props.history.push(`${RoutesPath.product.suggestion.list}`)} className="btn_white">
                            Historique des suggestions
                        </a>
                    )}
                    {acl.product.suggestion.add() && (
                        <button className="btn_bleu" data-shortcut_alias="create" onClick={() => this.props.history.push(`${RoutesPath.product.suggestion.add}`)}>
                            Suggérer un nouveau produit
                        </button>
                    )}
                </TopOptions>
                <MyProductsTable {...this.props}></MyProductsTable>
            </Main_container>
        );
    }
}

const Main_container = styled.div`
    height: 100%;
`;
const mapStateToProps = (state) => {
    return {
        selected: state.selcted,
    };
};
export default connect(mapStateToProps)(MyProductsPage);
